import { useEffect, useState } from "react"
import { Reconciliation } from "../../helpers/interfaces"
import { FormEditMode } from "../../helpers/constants"
import { createReconciliation, updateReconciliation } from "../../apiServices/CTBMappingKeysApi"
import CustomDialog from "../CustomDialog"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"
import { CustomTextField } from "../../layouts/themes"

interface Props {

    setFormEditMode: React.Dispatch<React.SetStateAction<number>>
    reconciliationEditMode: number
    setReconciliation: React.Dispatch<React.SetStateAction<Reconciliation[]>>
    reconciliation: Reconciliation[]
    reconciliationToEdit: string
    openReconciliationForm: boolean
    setOpenReconciliationForm: React.Dispatch<React.SetStateAction<boolean>>

}
function CreateEditReconciliation(props: Props) {
    const [reconciliationName, setReconciliationName] = useState<string>("");

    useEffect(() => {
        if (props.reconciliationEditMode === FormEditMode.EDIT) {
            var recName = props.reconciliation.find(e => e.id === props.reconciliationToEdit)
            if (!recName) return
            setReconciliationName(recName.name)

        }
    }, [props.reconciliation, props.reconciliationToEdit, props.reconciliationEditMode])

    function createNewReconciliation() {
        createReconciliation(reconciliationName).then(_rec => {
            props.setOpenReconciliationForm(false);
            props.setReconciliation(rec => [...rec, _rec])

        })
    }
    function updateNewReconciliation() {
        updateReconciliation(props.reconciliationToEdit, reconciliationName).then(result => {
            props.setOpenReconciliationForm(false);
            props.setReconciliation(rec => rec.map(a => a.id === props.reconciliationToEdit ? result : a))

        })
    }
    return (
        <>
            <CustomDialog dialogTitle={props.reconciliationEditMode === FormEditMode.CREATE ? 'Add New Reconciliation ' : 'Update Reconciliation '} setOpenDialog={props.setOpenReconciliationForm} openDialog={props.openReconciliationForm}>
                <form>
                    <div >
                        <label className='title-label'>Reconciliation Name <span className='important'>*</span></label>
                    </div>
                    <div className='col-12'>
                        <div className="form-group mb-0">
                            <div className="">
                                <CustomTextField size="small" id="outlined-basic" placeholder="Reconciliation Name" value={reconciliationName} onChange={(e) => setReconciliationName(e.target.value)} variant="outlined" sx={{width:'100%'}}/>

                            </div>
                        </div>
                    </div>
                    <br />


                    <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                        <Button disabled={!reconciliationName} variant="contained" color='secondary' onClick={props.reconciliationEditMode === FormEditMode.CREATE ? createNewReconciliation : updateNewReconciliation} >
                            <Add />&nbsp; {props.reconciliationEditMode === FormEditMode.CREATE ? 'Add New Reconciliation' : 'Update Reconciliation'}
                        </Button>
                    </div>
                </form >


            </CustomDialog>

        </>
    )
}
export default CreateEditReconciliation